// extracted by mini-css-extract-plugin
module.exports = {"InvoicePreviewInput":"ImportInvoicesInput_InvoicePreviewInput__1tJBo","OnDragOver":"ImportInvoicesInput_OnDragOver__143wM","NotAllowed":"ImportInvoicesInput_NotAllowed__3SVAv"};